import { Controller } from '@hotwired/stimulus';
import * as Turbo from "@hotwired/turbo"

export default class SelectMenuController extends Controller {
  handleChange(e) {
    const path = e.target.selectedOptions[0]?.getAttribute('href')
    if(path) Turbo.visit(path)
  }
}
